<template>
    <div class="video_call_notification_popup">
        <div class="video_call_notification_popup_center">
            <div class="video_call_notification_popup_center_content">
                <div class="video_call_notification_popup_inner">
                    <div class="video_call_notification_popup_header">
                        <h3>Incoming Call</h3>
                        <span class="close_icon" @click="callDeclinedMethod">
                            <i class="fa fa-times-circle" aria-hidden="true"></i>
                        </span>
                    </div>
                    <div class="video_call_notification_popup_body">
                        <h5>{{ callerInfo.callerName }} is calling you.</h5>
                        <p>The call will start as soon as you answer.</p>
                    </div>
                    <div class="video_call_notification_popup_footer">
                        <button class="btn btn-danger mr-3" @click="callDeclinedMethod">Decline</button>
                        <button class="btn btn-primary" @click="callAcceptMethod">
                            <i class="fa fa-phone mr-1" aria-hidden="true"></i> Accept
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */
import { bus } from '@/main';
import callingRingtone from '@/assets/audio/videocall_ringtone.mp3';
import commonSocket from "@/commonSocket/index.js";

export default {
    name: 'video-call-notification-popup',
    props: {
        callerInfo: {
            type: Object,
            required: true
        },
        roomId: {
            required: true
        }
    },
    data() {
        return {
            selfUserId: '',
            audioPlayer: null,
            autoCallDisconnectTimeout: null // Storing timer instance locally
        }
    },
    mounted() {
        if (localStorage.getItem('LoginedUserID')) {
            this.selfUserId = localStorage.getItem('LoginedUserID');
        }

        // Changed from setInterval to setTimeout since it only needs to run once after 30 seconds
        this.autoCallDisconnectTimeout = setTimeout(() => {
            this.callNotAnsweredFun();
        }, 30000);

        this.playSound(callingRingtone);
    },
    beforeDestroy() {
        // Essential cleanup to prevent memory leaks and ghost ringtones
        this.stopSound();
        if (this.autoCallDisconnectTimeout) {
            clearTimeout(this.autoCallDisconnectTimeout);
        }
        document.body.classList.remove('videoNotificationPopup');
    },
    methods: {
        playSound(sound) {
            if (sound) {
                this.audioPlayer = new Audio(sound);
                // Catch block added to handle modern browser autoplay restriction policies safely
                this.audioPlayer.play().catch(error => {
                    console.log("Autoplay prevented by browser until user interaction:", error);
                });
            }
        },
        stopSound() {
            if (!this.audioPlayer) return;
            this.audioPlayer.muted = true;
            this.audioPlayer.pause();
            this.audioPlayer.currentTime = 0;
            this.audioPlayer = null;
        },
        callAcceptMethod() {
            this.stopSound();
            clearTimeout(this.autoCallDisconnectTimeout);
            commonSocket.emit({
                type: "videoCallAccepted",
                targetId: this.callerInfo.callerID,
                roomId: this.roomId
            });
            bus.$emit('callerNotifiactionBus', false);
            this.$router.push('/video/conference/#' + this.roomId);

            // this.$store.dispatch('videoRoomIdGeneratedMethod', { user: this.roomId }).then((res) => {
            //     this.roomIdForVideoCall = res.data.data.id;
            //     commonSocket.emit({
            //         type: "videoCallAccepted",
            //         targetId: this.callerInfo.callerID,
            //         roomId: this.roomIdForVideoCall
            //     });
            //     bus.$emit('callerNotifiactionBus', false);
            //     this.$router.push('/video/conference/#' + this.roomIdForVideoCall);
            // }).catch((err) => {
            //     console.error("Error generating video room ID:", err);
            // });
        },
        callDeclinedMethod() {
            this.stopSound();
            clearTimeout(this.autoCallDisconnectTimeout);

            commonSocket.emit({
                type: "videoCallDecline",
                targetId: this.callerInfo.callerID,
                callerID: this.callerInfo.targetId,
            });
            bus.$emit('callerNotifiactionBus', false);
        },
        callNotAnsweredFun() {
            this.stopSound();
            commonSocket.emit({
                message: `Call Not received.`,
                type: "videoCallNotReceived",
                chatRoomId: this.roomId,
                targetId: this.callerInfo.callerID,
                callerID: this.callerInfo.targetId
            });
            bus.$emit('callerNotifiactionBus', false);
        }
    }
}
</script>

<style lang="scss" scoped>
.video_call_notification_popup {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 100000;
    background: rgba(0, 0, 0, 0.9);
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    color: #ffffff;
}

.video_call_notification_popup_inner {
    background: #1c1e1f;
    max-width: 540px;
    padding: 20px;
    border-radius: 5px;
    margin: 0 auto;
    width: 100%;
    position: relative;
}

.video_call_notification_popup_center {
    height: 100%;
    display: table;
    width: 100%;
}

.video_call_notification_popup_center_content {
    display: table-cell;
    vertical-align: middle;
}

.video_call_notification_popup_body {
    margin: 30px 0;
}

.close_icon {
    font-size: 26px;
    position: absolute;
    top: 5px;
    right: 10px;

    .fa {
        cursor: pointer;
    }
}
</style>